<template>
  <div>
    <div id="admin-preloader" v-if="loading">
      <div id="admin-loader-text">Loading</div>
      <div id="admin-loader"></div>
    </div>
    <div id="admin-preloader" v-if="loading1">
      <div id="admin-loader-text">Adding</div>
      <div id="admin-loader"></div>
    </div>
    <div class="" v-if="changed">
      <b-modal
        v-model="modalShow"
        ok-only
        centered
        class="text-center text-info"
      >
        Offer Added
      </b-modal>
      <b-modal
        v-model="modalShow2"
        ok-only
        centered
        class="text-center text-danger"
      >
        You have added maximum offers. You can't add more offers.
      </b-modal>
      <div class="m-auto text-right pt-3">
        <router-link
          :to="{ name: 'alloffers' }"
          class="text-white"
          style="text-decoration: none"
          ><el-button type="primary" size="medium">
            <i class="el-icon-view mr-2"></i>View Offers</el-button
          ></router-link
        >
      </div>
      <h2 class="m-auto text-info text-center pt-3 pb-1">Add offers</h2>
      <div class="file-upload col-12 col-md-6 pb-3" style="margin-top: 30px">
        <div class="image-upload-wrap" style="height: 100px">
          <input
            class="file-upload-input"
            type="file"
            @change="fileSelect1"
            accept=".jpg, .jpeg"
          />
          <div class="drag-text">
            <h6 class="pt-3">Drag and drop or select Image</h6>
            <h6></h6>
          </div>
        </div>
        <div
          class="file-upload-content mx-auto text-center"
          :style="{ display: visible1 }"
        >
          <img class="file-upload-image" :src="imageUrl" alt="" />
          <div class="image-title-wrap"></div>
        </div>
      </div>
      <div style="margin-top: 15px" class="col-md-6 m-auto pt-3">
        <el-input
          placeholder="Discount"
          v-model="dis"
          class="input-with-select"
          type="number"
          min="0"
          max="100"
        >
          <template slot="append"><i class="fa fa-percent"></i></template>
        </el-input>
        <el-input
          class="pt-3"
          type="textarea"
          maxlength="1000"
          :autosize="{ minRows: 4, maxRows: 12 }"
          placeholder="Description"
          v-model="desc"
        >
        </el-input>
        <el-button type="primary" class="mt-3 float-right" @click="addOffer()"
          >Add</el-button
        >
      </div>

      <!-- <div class="alert">
 
    </div>
  <div class="mt-5">
    <h3 class="text-center mt-3 mb-2 m-auto">Sample Offer Notification</h3>
     <div class="alert warning text-center mt-4">
  <span class="closebtn">&times;</span>  
  <strong>{{dis}}%</strong> Discount on {{cat}} items.
  </div>
  </div> -->
    </div>
  </div>
</template>

<script>
import AdminPanel from "./Admin";
import ImageCompressor from "image-compressor.js";
import db from "../../config/FirebaseInit";
import firebase from "firebase/app";
export default {
  name: "offers",
  components: {
    AdminPanel,
  },
  data() {
    return {
      cat: "",
      dis: "",
      visible: "block",
      visible1: "none",
      imageUrl: "",
      image1: "",
      desc: "",
      modalShow: false,
      modalShow2: false,
      shops: [],
      loading: false,
      loading1: false,
      changed: false,
    };
  },
  created() {
    this.backToTop();
    this.loading = true;
    this.changed = false;
    this.$store.state.secondaryDatabase
      .collection("shops")
      .where("owner", "==", firebase.auth().currentUser.uid)
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          const data = {
            id: doc.id,
            shoptype: doc.data().shoptype,
            curOffers: doc.data().curOffers,
            plan: doc.data().plan,
          };
          this.shops.push(data);
          this.loading = false;
          this.changed = true;
        });
      });
  },
  methods: {
    backToTop: function () {
      $("html,body").stop().animate(
        {
          scrollTop: 0,
        },
        "fast",
        "swing"
      );
    },
    addOffer() {
      this.loading1 = true;
      this.changed = false;
      var maxOffers;
      if (this.shops[0].plan == "Starter") {
        maxOffers = 10;
      } else {
        maxOffers = 20;
      }
      if (this.shops[0].curOffers < maxOffers) {
        //console.log('uid',firebase.auth().currentUser.uid)
        this.$store.state.secondaryDatabase
          .collection("offers")
          .add({
            img: this.image1,
            dis: this.dis,
            desc: this.desc,
            owner: firebase.auth().currentUser.uid,
            //shopID: this.shops[0].id
          })
          .then((doc) => {
            //console.log('doc is', doc)
            // this.modalShow = true
            this.shops[0].curOffers += 1;
            this.$store.state.secondaryDatabase
              .collection("shops")
              .doc(this.shops[0].id)
              .update({
                curOffers: this.shops[0].curOffers,
              })
              .then((doc) => {
                //console.log('doc is', doc)
                this.loading1 = false;
                this.changed = true;
                this.modalShow = true;
              });
          })
          .catch((error) => alert(error));
      } else {
        this.loading1 = false;
        this.changed = true;
        this.modalShow2 = true;
      }
    },

    fileSelect1(event) {
      //console.log('event is', event)
      const files = event.target.files;
      let filename = files[0].name;
      if (
        files[0].type == "image/png" ||
        files[0].type == "image/gif" ||
        files[0].type == "image/svg+xml" ||
        files[0].type == "image/tiff"
      ) {
        alert(
          "File " +
            files[0].name +
            " is not type of jpeg or jpg!. You cannot upload other types of images."
        );
      } else if (files[0].size > 5000200) {
        alert("File " + files[0].name + " is too large!");
      } else {
        const reader = new FileReader();
        reader.addEventListener("load", () => {
          this.visible = "none";
          this.imageUrl = reader.result;
          this.visible1 = "block";
        });
        reader.readAsDataURL(files[0]);
        //this.image = files[0];
        const imageCompressor = new ImageCompressor();
        imageCompressor
          .compress(files[0], { quality: 0.6, width: 720, height: 1340 })
          .then((result) => {
            // Handle the compressed image file.
            if (result.size >= 1000000) {
              const imageCompressor = new ImageCompressor();
              imageCompressor
                .compress(result, { quality: 0.5 })
                .then((result) => {
                  const fileReader = new FileReader();

                  // This fires after the blob has been read/loaded.
                  fileReader.addEventListener("load", () => {
                    this.image1 = fileReader.result;

                    //console.log('image is',this.image1)
                  });

                  // Start reading the blob as text.
                  fileReader.readAsDataURL(result);

                  ////console.log(filename)
                  //console.log(result.size)
                  //console.log('image is',result)
                });
            } else {
              var fileReader = new FileReader();
              fileReader.addEventListener("load", () => {
                this.image1 = fileReader.result;

                //console.log('else image is',this.image1)
              });
              fileReader.readAsDataURL(result);
              ////console.log(filename)
              //console.log('else',result.size)
              //console.log('ekse image is',result)
            }
          })

          .catch((err) => {
            // Handle the error
            //console.log("error is" + err)
          });
      }
    },
  },
};
</script>
<style scoped>
@import url("~@/assets/admin/css/imgupload.css");
@import url("~@/assets/admin/css/admin-loader.css");
.el-select .el-input {
  width: 110px;
}
.input-with-select .el-input-group__prepend {
  background-color: #fff;
}

.alert {
  padding: 10px;

  color: white;
  opacity: 1;
  transition: opacity 0.6s;
  margin-bottom: 15px;
}

.alert.warning {
  background-color: #ff4d4d;
}

.closebtn {
  margin-left: 15px;
  color: white;
  font-weight: bold;
  float: right;
  font-size: 22px;
  line-height: 20px;
  cursor: pointer;
  transition: 0.3s;
}

.closebtn:hover {
  color: black;
}
</style>


// WEBPACK FOOTER //
// src/components/admin/Offers.vue